import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const argentineCities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca'];
const argentineNames = ['Martín González', 'Lucía Fernández', 'Santiago Rodríguez', 'Valentina López', 'Mateo Pérez', 'Sofía Martínez', 'Benjamín García', 'Catalina Romero', 'Joaquín Silva', 'Camila Torres', 'Tomás Díaz', 'Florencia Castro', 'Agustín Morales', 'Victoria Sánchez', 'Lucas Méndez', 'Julieta Vargas'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = argentineNames[Math.floor(Math.random() * argentineNames.length)];
      const randomCity = argentineCities[Math.floor(Math.random() * argentineCities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialDelay = setTimeout(showPopup, 15000);
    const interval = setInterval(showPopup, 90000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-3 left-3 md:bottom-4 md:left-4 z-50 animate-slide-in" data-id="element-359" data-mp="raavojwis41t">
      <div className="bg-[#121212] rounded-lg shadow-[0_0_15px_rgba(156,22,163,0.3)] p-2.5 md:p-3 max-w-[260px] md:max-w-xs border border-[#9C16A3]/50" data-id="element-360" data-mp="150w7jonk3dq7">
        <div className="flex items-start gap-2" data-id="element-361" data-mp="1f058j1gu9sm2">
          <div className="bg-[#9C16A3]/20 rounded-full p-1 md:p-1.5 flex-shrink-0" data-id="element-362" data-mp="1f0wsff12q1wi">
            <ShoppingBagIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#FC9DFF]" data-id="element-363" data-mp="1a2d4xa6u0i21" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-364" data-mp="1h5jnq01wl0ax">
            <p className="font-bold text-white text-[10px] md:text-xs" data-id="element-365" data-mp="1h2np09i8e7lf">
              ¡Compra reciente!
            </p>
            <p className="text-gray-300 text-[10px] md:text-xs" data-id="element-366" data-mp="1r2y4y1vnht4a">
              <span className="font-semibold text-white" data-id="element-367" data-mp="1r0lcuvw6i2di">
                {currentPurchase.name}
              </span>{' '}
              de {currentPurchase.city} compró{' '}
              <span className="font-semibold text-[#FC9DFF]" data-id="element-368" data-mp="20rps7wprnp8v">
                Dominando Shopify
              </span>
            </p>
            <p className="text-gray-500 text-[9px] md:text-[10px] mt-0.5" data-id="element-369" data-mp="24w5t1jkiw6h8">
              Hace unos minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-500 hover:text-[#FC9DFF] transition-colors flex-shrink-0" data-id="element-370" data-mp="2essd4650yti7">
            <XIcon className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-371" data-mp="fhhh1jfugqjq" />
          </button>
        </div>
      </div>
    </div>;
}